import React from "react";

import img1 from "../../assets/images/exImg1.png";
import img2 from "../../assets/images/exImg2.png";
import img3 from "../../assets/images/expImg3.png";

import expHd from "../../assets/images/An Experience.png";

const cards = [
  {
    title: "Monthly Specials are Here!",
    desc: "New items and seasonal favorites, updated every month. Limited time picks worth trying while they're here.",
    img: img1,
    url: "/special",
  },
  {
    title: "Breakfast Favorites!",
    desc: "Hot breakfast sandwiches, fresh coffee and simple, good food to start your day right.",
    img: img2,
    url: "/menu?section=breakfastspecials",     
  },
  {
    title: "Fish Fridays: A Local Favorite for Decades!",
    desc: "Crispy, golden fish and chips every Friday! A Main's tradition you won't want to miss.",
    img: img3,
    url: "/menu?section=seafoodfridays",
  },
];

const ExperienceSection = () => {
  return (
    <section id="experience-section">
      <div className="wrapper">
        <div className="experience-header">
          <span>
            <img src={expHd} className="exp-hd" />
          </span>
          <h2>DISCOVER WHAT ELSE WE’RE SERVING UP</h2>
        </div>

        <div className="experience-cards">
          {cards.map((item, index) => (
            <div className="experience-card" key={index}>
              <img src={item.img} alt={item.title} className="exp-cardImg" />
              <div className="exp-body">
                <div>
                  <h4>{item.title}</h4>
                  <p>{item.desc}</p>
                </div>
                <a href={item.url}>LEARN MORE →</a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
